import { render, staticRenderFns } from "./onboarding-packet.vue?vue&type=template&id=57045c23&scoped=true&"
import script from "./onboarding-packet.vue?vue&type=script&lang=js&"
export * from "./onboarding-packet.vue?vue&type=script&lang=js&"
import style0 from "./onboarding-packet.vue?vue&type=style&index=0&id=57045c23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57045c23",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AccountFranchisorLayout: require('/home/circleci/repo/components/account-franchisor/AccountFranchisorLayout.vue').default})
